<template>
    <!-- 轮播图 -->
    <div class="swiper" @touchstart="$emit('touch')" id="swiper">
        <mt-swipe :auto="timeGap" @change="imgChange($event)">
            <mt-swipe-item key="1" v-for="(item, index) in swiperData" :key="item"
                           :class="mp4Reg.test(item) ? 'flex-item' : ''">
                <img v-if="!mp4Reg.test(item)" :src="item" alt="" :ref="'img'+index" @load="heightFlex(index)">
                <video v-if="mp4Reg.test(item)" :src="item" muted="muted" loop controls playsinline="playsinline"
                       webkit-playsinline="webkit-playsinline" :ref="'img'+index"
                       poster="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"></video>
            </mt-swipe-item>
        </mt-swipe>
    </div>
</template>

<script>
  export default {
    props: {
      swiperData: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        // 轮播图高度
        swiperHeight: 0,
        // 最高的图片
        maxHeightImg: {},
        // 视频路径正则
        mp4Reg: /.+\.mp4/,
        // 轮播时间间隔
        timeGap: 4000
      }
    },
    created() {
      // 有视频时停止轮播
      this.swiperData.map(item => {
        if (this.mp4Reg.test(item)) {
          this.timeGap = 0
        }
      })
    },
    mounted() {
      // 初始长宽比1：1
      document.getElementsByClassName('mint-swipe')[0].style.height = window.innerWidth >= 640 ? 640 + 'px' : window.innerWidth + 'px';
      // 第一个是视频时自动播放，并自适应高度
      if (this.mp4Reg.test(this.swiperData[0])) {
        const timer = setInterval(() => {
          if (this.heightFlex(0) !== 'err') {
            this.$refs.img0[0].muted = 'muted';
            this.$refs.img0[0].play();
            clearInterval(timer);
          }
        }, 500);
      }
      // 视口变化高度变化
      window.onresize = () => {
        if (this.maxHeightImg[0] && this.maxHeightImg[0].naturalHeight && this.maxHeightImg[0].naturalWidth) {
          this.swiperHeight = this.maxHeightImg[0].naturalHeight / this.maxHeightImg[0].naturalWidth * (window.innerWidth >= 640 ? 640 : window.innerWidth);
          document.getElementsByClassName('mint-swipe')[0].style.height = this.swiperHeight + 'px';
        }
      }
    },
    methods: {
      /**
       * 轮播图变为视频时自动播放，其他视频暂停，并进行轮播高度适应
       * @param index 轮播索引
       */
      imgChange(index) {
        if (this.$refs['img' + index][0].tagName === 'VIDEO') {
          const videoList = document.getElementById('swiper').getElementsByTagName('video');
          for (let i = 0; i < videoList.length; i++) {
            videoList[i].pause();
          }
          this.$refs['img' + index][0].play();
          if (this.$refs['img' + index][0].videoHeight && this.$refs['img' + index][0].videoWidth) {
            this.$refs['img' + index][0].naturalHeight = this.$refs['img' + index][0].videoHeight;
            this.$refs['img' + index][0].naturalWidth = this.$refs['img' + index][0].videoWidth;
          }
          this.heightFlex(index);
        }
      },
      /**
       * 轮播高度适应
       * @param index 轮播索引
       * @returns {string} 'err'：无长宽数据
       */
      heightFlex(index) {
        const formatHeight = this.$refs['img' + index][0].naturalHeight / this.$refs['img' + index][0].naturalWidth * (window.innerWidth >= 640 ? 640 : window.innerWidth);
        if (isNaN(formatHeight)) {
          return 'err'
        }
        if (formatHeight > this.swiperHeight || !this.maxHeightImg[0]) {
          this.swiperHeight = formatHeight;
          document.getElementsByClassName('mint-swipe')[0].style.height = this.swiperHeight + 'px';
          this.maxHeightImg = this.$refs['img' + index];
        }
        const classVal = this.$refs['img' + index][0].parentElement.getAttribute('class').concat(' flex-item');
        this.$refs['img' + index][0].parentElement.setAttribute('class', classVal);
      }
    }
  }
</script>

<style>
    .swiper {
        width: 100%;
        position: relative;
    }

    .swiper .mint-swipe {
        /*height: 100vw;*/
    }

    .swiper .mint-swipe .mint-swipe-items-wrap {
        width: 100%;
        height: 100%;

    }

    .swiper .mint-swipe .flex-item {
        display: flex !important;
        align-items: center !important; /*副轴居中*/

    }

    .swiper .mint-swipe img,
    .swiper .mint-swipe video {
        vertical-align: middle;
        width: 100%;
        flex: 1;
        display: flex;
        justify-content: center; /*主轴居中*/
    }


</style>



// WEBPACK FOOTER //
// src/components/detail/swiper.vue